import type {
  ClassroomLessonClassResource,
  ClassroomModulesResource,
} from "api/generated";
import type {
  ClassroomLessonClass,
  ClassroomLessonClassListItem,
  ClassroomModules,
} from "classroom/types";

const mapLessonClassModules = (
  modules: ClassroomModulesResource,
): ClassroomModules => ({
  portfolio: modules.portfolio,
  meetings: modules.meetings,
  learning_goals: modules.learning_goals,
  conversations: modules.conversations,
});

export const lessonClassFromDto = (
  resource: ClassroomLessonClassResource,
): ClassroomLessonClass => ({
  id: resource.id,
  name: resource.name,
  // Prefer the full subject name; fall back to the shortage code when it is
  // blank (null or empty/whitespace).
  subjectLabel:
    resource.subject_name !== null && resource.subject_name.trim() !== ""
      ? resource.subject_name
      : resource.subject_shortage,
  subjectShortage: resource.subject_shortage,
  mentors: resource.mentors,
  teachers: resource.teachers,
  modules: mapLessonClassModules(resource.modules),
});

interface ClassroomLessonClassListItemResource {
  id: number;
  name: string;
  subject_shortage: string;
  subject_name: string | null;
}

export const lessonClassListItemFromDto = (
  resource: ClassroomLessonClassListItemResource,
): ClassroomLessonClassListItem => ({
  id: resource.id,
  name: resource.name,
  subjectShortage: resource.subject_shortage,
  subjectName: resource.subject_name,
});
